<template>
  <div class="app-forgot-password-succeeded">
    <dyn-slot :slot-data="slotData">
      <slot name="mainTitleAlready" v-if="this.alreadyInitiated"></slot>
      <slot name="mainTitle" v-else></slot>
      <slot name="mainText">
        Eine E-Mail wurde erfolgreich an Ihre hinterlegte E-Mail-Adresse versandt.
      </slot>
    </dyn-slot>
    <b-button class="send" variant="primary" type="button" :disabled="countdownCheck"  v-on:click="save">
      <slot name="buttonLabel">Erneut Senden</slot>
    </b-button>
  </div>
</template>

<script>
import moment from 'moment'
import { BButton } from 'bootstrap-vue'
import { mapGetters, mapMutations } from 'vuex'

export default {
  components: { BButton },
  name: 'ForgotPasswordSucceeded',
  data () {
    return {
      now: new Date(),
      interval: null
    }
  },
  created: function () {
    this.startTimer()
  },
  destroyed () {
    clearInterval(this.interval)
  },
  computed: {
    ...mapGetters('forgotPassword', [
      'validityPeriod',
      'alreadyInitiated'
    ]),
    transformToDayFormat: function () {
      return moment(String(this.validityPeriod)).format('DD.MM.YYYY, HH:mm:ss')
    },
    transformToCountdown: function () {
      return moment.utc(this.countDown).format('mm:ss')
    },
    countDown () {
      return moment(this.validityPeriod) - moment(this.now)
    },
    countdownCheck () {
      return this.countDown > 0
    },
    slotData () {
      return {
        countdownCheck: this.countdownCheck,
        transformToDayFormat: this.transformToDayFormat,
        transformToCountdown: this.transformToCountdown
      }
    }
  },
  methods: {
    ...mapMutations('forgotPassword', [
      'restartProcess'
    ]),
    startTimer () {
      this.interval = setInterval(function () {
        this.now = new Date()
      }.bind(this), 1000)
    },
    save () {
      this.restartProcess()
    }
  }
}
</script>
